export { default } from "./diagram4.component";
